import If from "@mobi/components/If"

import CardIcon from "images/icons/card.svg"
import DownloadIcon from "images/icons/download.svg"
import MobileAddIcon from "images/icons/mobile-add.svg"
import MulherComemorandoBemCamisaLaranjaSvg from "images/mulher_comemorando_bem_camisa_laranja.svg"
import MulherComemorandoBemSvg from "images/mulher_comemorando_bem_outlined.svg"
import QRCodeCGIFinanciado from "images/qrcode_cgi_financiado.svg"

import "./style.scss"

const Financed = ({ isMobile }) => {
  return (
    <div className="financedQualificationRedirect">
      <h2 className="financedQualificationRedirect__title">
        Para simular com um imóvel financiado, é necessário acessar o app
      </h2>
      <p className="financedQualificationRedirect__text">
        Você que já tem um financiamento imobiliário ou Crédito com Garantia de
        Imóvel no Itaú pode aproveitar taxas menores. Acesse o aplicativo para
        fazer uma simulação, é rápido, fácil e seguro.
      </p>
      <div className="financedQualificationRedirect__steps">
        <div className="financedQualificationRedirect__step">
          <DownloadIcon
            className="financedQualificationRedirect__step-icon"
            aria-hidden="true"
          />
          <p className="financedQualificationRedirect__step-text">
            Aponte a câmera do seu celular para o QR Code
          </p>
        </div>
        <div className="financedQualificationRedirect__step">
          <MobileAddIcon
            className="financedQualificationRedirect__step-icon"
            aria-hidden="true"
          />
          <p className="financedQualificationRedirect__step-text">
            Acesse o app e faça o seu login
          </p>
        </div>
        <div className="financedQualificationRedirect__step">
          <CardIcon
            className="financedQualificationRedirect__step-icon"
            aria-hidden="true"
          />
          <p className="financedQualificationRedirect__step-text">
            Continue a sua simulação pelo App
          </p>
        </div>
      </div>
      <If
        condition={!isMobile}
        renderIf={
          <div className="financedQualificationRedirect__qrcodeCard">
            <QRCodeCGIFinanciado
              role="img"
              aria-label="QR Code direcionando para o aplicativo. Acesse o app, vá para a área de crédito e selecione a opção crédito com garantia de imóvel"
            />
          </div>
        }
      />
      <div className="financedQualificationRedirect__illustration">
        <If
          condition={isMobile}
          renderIf={<MulherComemorandoBemCamisaLaranjaSvg aria-hidden="true" />}
          renderElse={<MulherComemorandoBemSvg aria-hidden="true" />}
        />
      </div>
    </div>
  )
}

export default Financed
